<template>
  <span @click="grabar()">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          :loading="loading"
        >
          <v-icon :color="color" left> mdi-content-save </v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip ? $utilidades.traduccion({ texto: tooltip }) : $utilidades.traduccion({ texto: text }) }}</span>
    </v-tooltip>

  </span>
</template>

<script>
import { Utilidades } from '@/Util/Utilidades';
export default {
  name: "BtnGrabar",
  props: {
    rounded: {
      type: Boolean,
      default: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
    textButton: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Grabar",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "success",
    },
    tooltip: {
      type: String,
      default: "",
    },
    loading: Boolean
  },
  components: {},
  mounted(){
    this.text = Utilidades.traduccion({ texto: "Grabar", tag: "GRABAR" });
  },
  methods: {
    grabar() {
      this.$emit("grabar");
    },
  },
};
</script>